import React, { Suspense, lazy } from "react";
import { Navigate, Route, useParams } from "react-router-dom";
import { RequirePortalAuth } from "../pages/Login";
import EnterpriseControlLayout from "./EnterpriseControlLayout";
import { ENTERPRISE_CONTROL_BASE } from "./constants";
import PortalRouteFallback from "../components/PortalRouteFallback";

const Fallback = () => <PortalRouteFallback />;

const EnterpriseDashboardPage = lazy(() => import("./pages/EnterpriseDashboardPage"));
const EnterpriseOrganizationsPage = lazy(() => import("./pages/EnterpriseOrganizationsPage"));
const EnterpriseOrganizationDetailPage = lazy(() => import("./pages/EnterpriseOrganizationDetailPage"));
const EnterpriseLicensesHubPage = lazy(() => import("./pages/EnterpriseLicensesHubPage"));
const EnterpriseAuditPage = lazy(() => import("./pages/EnterpriseAuditPage"));

const PORTAL_HOME = "/nyafaz-portal/home";
const PORTAL_ORG_EDIT_BASE = "/nyafaz-portal/organizations";

function LegacyOrgDetailRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${ENTERPRISE_CONTROL_BASE}/organizations/${orgId}`} replace />;
}

function ManageToOrgRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${ENTERPRISE_CONTROL_BASE}/organizations/${orgId}`} replace />;
}

function EnterpriseControlCreateRedirect() {
  return <Navigate to={PORTAL_HOME} replace />;
}

function EnterpriseControlEditRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${PORTAL_ORG_EDIT_BASE}/${orgId}/edit`} replace />;
}

export function renderEnterpriseControlRoutes() {
  return (
    <Route
      path={ENTERPRISE_CONTROL_BASE}
      element={
        <RequirePortalAuth>
          <EnterpriseControlLayout />
        </RequirePortalAuth>
      }
    >
      <Route
        index
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseDashboardPage />
          </Suspense>
        }
      />
      <Route
        path="organizations"
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseOrganizationsPage />
          </Suspense>
        }
      />
      <Route
        path="organizations/:orgId"
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseOrganizationDetailPage />
          </Suspense>
        }
      />
      <Route path="organizations/:orgId/manage" element={<ManageToOrgRedirect />} />
      <Route path="organizations/new" element={<EnterpriseControlCreateRedirect />} />
      <Route path="organizations/:orgId/edit" element={<EnterpriseControlEditRedirect />} />
      <Route
        path="licenses"
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseLicensesHubPage />
          </Suspense>
        }
      />
      <Route
        path="audit"
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseAuditPage />
          </Suspense>
        }
      />
      <Route path="*" element={<Navigate to={ENTERPRISE_CONTROL_BASE} replace />} />
    </Route>
  );
}

export { LegacyOrgDetailRedirect, ENTERPRISE_CONTROL_BASE };
